import React, { Component } from 'react';
import SandboxedHtmlBody from './SandboxedHtmlBody.js';
import ReplyForm from './ReplyForm.js';

class MessageViewer extends Component {
    constructor() {
        super();
        this.state = {
            showReplyForm: false
        };
    }

    formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleString();
    };

    toggleReplyForm = () => {
        this.setState(prevState => ({
            showReplyForm: !prevState.showReplyForm
        }));
    };

    handleReply = async (subject, body) => {
        const { message, onReply } = this.props;
        await onReply(message.id, subject, body);
        this.setState({ showReplyForm: false });
    };

    renderMessageBody = () => {
        const { message } = this.props;

        // Prefer HTML content if available, otherwise use text
        if (message.html_body) {
            return (
                <SandboxedHtmlBody
                    className="message-html-body"
                    html={message.html_body}
                />
            );
        } else if (message.text_body) {
            return (
                <div className="message-text-body">
                    <pre>{message.text_body}</pre>
                </div>
            );
        } else {
            return (
                <div className="message-no-body">
                    <p><em>This message has no content</em></p>
                </div>
            );
        }
    };

    render() {
        const { message, onDelete } = this.props;
        const { showReplyForm } = this.state;

        if (!message) {
            return null;
        }

        return (
            <div className="message-viewer">
                <div className="message-header">
                    <div className="message-header-main">
                        <h4 className="message-subject">{message.subject || '(No Subject)'}</h4>
                        
                        <div className="message-meta">
                            <div className="message-from">
                                <strong>From:</strong> {message.from_name ? `${message.from_name} <${message.from}>` : message.from}
                            </div>
                            
                            <div className="message-to">
                                <strong>To:</strong> {message.to}
                            </div>
                            
                            <div className="message-date">
                                <strong>Date:</strong> {this.formatDate(message.date)}
                            </div>
                            
                            {message.has_attachments && (
                                <div className="message-attachments">
                                    <strong>[Attachment] Has attachments</strong>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div style={{display: 'flex', gap: '8px', marginTop: '8px'}}>
                        <button 
                            style={{
                                backgroundColor: '#294081',
                                color: 'white',
                                border: '1px solid #294081',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                minWidth: '80px'
                            }}
                            onClick={this.toggleReplyForm}
                        >
                            Reply
                        </button>
                        
                        <button 
                            style={{
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: '1px solid #dc3545',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                minWidth: '80px'
                            }}
                            onClick={onDelete}
                        >
                            Delete
                        </button>
                    </div>
                </div>

                {showReplyForm && (
                    <div className="reply-section">
                        <ReplyForm
                            originalMessage={message}
                            onSend={this.handleReply}
                            onCancel={this.toggleReplyForm}
                        />
                    </div>
                )}

                <div className="message-body">
                    {this.renderMessageBody()}
                </div>
            </div>
        );
    }
}

export default MessageViewer;